export const SET_COUNTRIES = "SET_COUNTRIES";
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";

export const SET_WHITELISTED_COUNTRIES = "SET_WHITELISTED_COUNTRIES";
export const GET_WHITELISTED_COUNTRIES = "GET_WHITELISTED_COUNTRIES";

export const GET_COUNTRIES = "GET_COUNTRIES";